
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFetch } from '../../../services/transports';
import { languages } from '../../../constants';
import { shortageReasons } from '../../../api/demandShortage';
import { LabeledSelect } from '..';

export const ShortageReasonsSelect = ({ ...props }) => {

  const [ t ] = useTranslation();
  const { i18n } = useTranslation();


  const [ countries, setCountries ] = useState([]);
  const [ { data }, fetchCountriesList ] = useFetch(shortageReasons,
    useCallback(response => response?.data?.container));


  useEffect(() => {
    const list = data && data.slice().map(item => ({
      value: `${item.id}`,
      text: i18n.language === languages.EN ? `${item.nameEn}` : `${item.nameAr}`
    }));
    setCountries(list);
  }, [ data ]);

  useEffect(() => {
    fetchCountriesList();
  }, []);


  return (
    <LabeledSelect
      { ...props }
      showSearch={ true }
      searchDelay={ 0 }
      options={ countries }
      filterOption={ true }
      EmptyComponent={ t('ERR.noMatchedCountry') }
      allowClear
      placeholder={ t('fields.choose') }
    />
  );
};
